import Button from '@modules/common/components/button';
import Text from '@modules/common/components/text';

type PageStatusMessageProps = {
  /** 顯示的標題文字 */
  title: string;
  /** 顯示的說明文字 */
  description: string;
  /** data-testid 用於測試辨識 */
  'data-testid': string;
  /** 重新載入回呼，若提供則顯示「重新載入」按鈕 */
  onRetry?: () => void;
};

/**
 * 頁面狀態訊息元件，用於 error / not-found 等非正常狀態。
 * 統一 order confirmed 頁面與 order details 頁面的 error/not-found UI。
 */
const PageStatusMessage = ({
  title,
  description,
  'data-testid': dataTestId,
  onRetry,
}: PageStatusMessageProps) => (
  <div
    className="flex flex-col items-center justify-center gap-4 py-12"
    data-testid={dataTestId}
  >
    <Text variant="large-semi">{title}</Text>
    <Text variant="base-regular" className="text-black-10">
      {description}
    </Text>
    {onRetry && (
      <Button variant="outlined" onClick={onRetry}>
        重新載入
      </Button>
    )}
  </div>
);

export default PageStatusMessage;
